import { useIsSubscriptionEnabled } from "@/hooks/use-is-subscription-enabled";
import { initRevenueCat, refreshRevenueCatAttribution } from "@/utils/revenue-cat";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { PropsWithChildren, useEffect } from "react";

export const RevenueCatProvider = ({ children }: PropsWithChildren) => {
  const { isEnabled, isResolved } = useIsSubscriptionEnabled();

  useEffect(() => {
    if (!isResolved || !isEnabled) {
      return;
    }

    initRevenueCat(isEnabled);
  }, [isEnabled, isResolved]);

  useEffect(() => {
    if (!isResolved || !isEnabled || Capacitor.getPlatform() !== "ios") return;
    const refresh = () => {
      void refreshRevenueCatAttribution();
    };
    window.addEventListener("nutricoach:tracking-status-changed", refresh);
    const listener = App.addListener("appStateChange", ({ isActive }) => {
      if (isActive) refresh();
    });
    return () => {
      window.removeEventListener("nutricoach:tracking-status-changed", refresh);
      void listener.then((handle) => handle.remove()).catch(() => undefined);
    };
  }, [isEnabled, isResolved]);

  return <>{children}</>;
};
